import React from "react";
import "./../../UaeAttestation/UaeReq/UaeReq.css";

const AustraliaReqMain = () => {
  return (
    <div className="uaeReqMainContainer">
      <div className="uaeReqMainContent">
        <h3>Requirement of apostille for Australia:</h3>
        <p>
          Legalization for Australia has its own prerequisite in the visa
          procedure & expansion of the business in Australia. Apostille is
          needed as it is included in the Australia that is a part of the Hague
          Convention which is also known as the Apostille Convention. There are
          policies of Australia that require documents with MEA sticker to allow
          a visitor to enter their nation. It is a part of safety that shows the
          trustworthiness of the documents. Therefore, the legalization of
          documents becomes essential for these reasons.
        </p>
      </div>
      <div className="uaeReqMainContent">
        <h3>Overall time to get Document Apostille:</h3>
        <p>
          The time-span required forGoodwayattestationApostille for
          AustraliaGoodwayattestation depends upon various factors such as which
          state the certificate was issued from, or the kinds of documents, or
          the authority you require it from. Generally, it will take around 2-3
          working days accomplish the whole process
          ofGoodwayattestationApostille service in Bangalore for certificates.
        </p>
      </div>
    </div>
  );
};

export default AustraliaReqMain;
